import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorHandler } from '@root/utils/error-handler.service';
import {PageEvent} from '@angular/material/paginator';
import { InvestorListService } from '@investor-list/investor-list.service';
import { InvestorListData } from '@investor-list/investor-list-container.model';

@Component({
  selector: 'app-investor-list',
  templateUrl: './investor-list.component.html',
  styleUrls: ['./investor-list.component.scss'],
  providers: [InvestorListService],
})
export class InvestorListComponent implements OnInit {
  constructor(
    private investorListService: InvestorListService,
    private errorHandler: ErrorHandler,
    public dialog: MatDialog) {}

  public searchText: string;

  // MatPaginator Inputs
  public totalRecords : number;

  public pageSize = 20;
  
  public pageNumber:number = 0;

  public investorList: InvestorListData[] = [];

  pageSizeOptions: number[] = [20, 50, 100, 500];

  public isLoading = false;

  ngOnInit() {
    this.readInvestorList();
  }

  public readInvestorList(query?:string) {
 
    const obj = {};
    this.isLoading = true;
    this.investorListService.getInvestorList(obj, this.pageNumber + 1, this.pageSize, query).subscribe(
      (response) => {
        if (response.status === 0) {
          this.investorList = response.data.deviceDetails;
          this.totalRecords = response.data.totalRecords;
        }
        if(response.status === -1 && response.error.errorMessage === 'No data found!'){
            this.investorList = [];
        }else{
          this.errorHandler.handleError(response);
          this.isLoading = false;
        }
       
      },
      (error) => {
        this.errorHandler.handleError(error);
        this.isLoading = false;
      }
    );
  }

  public onInvestorRefresh(){
    this.readInvestorList();
  }

  public onPageChange(pageEvent: PageEvent){
    this.pageNumber = pageEvent.pageIndex;
    this.pageSize = pageEvent.pageSize;
    this.readInvestorList();
  }

  public onChangeSearchInput(value: string){
    setTimeout(()=>{
      this.pageNumber =0;
      this.readInvestorList(value);
    },1000)
  }

  public reset(value: string){
    if(!value){
      this.readInvestorList();
    }
  }
}
